@if (groupedNotifications() !== undefined) {
  @let first = groupedNotifications().notifications[0];
  <div class="notification mb-2 rounded-box" tabindex="0" [ngClass]="first.isRead ? 'read' : 'unread'">
    <div class="flex flex-col items-start px-4 py-2">
      <span class="flex w-full items-center">
        <daisy-avatar class="shrink-0" fallbackIcon="fa-solid fa-siren-on" size="2.25rem" shape="rounded" />
        <div class="ml-3 flex w-full flex-col">
          <div class="flex items-center justify-between">
            <div>
              <span class="items-center">
                {{ first.content?.primaryText }}
              </span>

              <!-- [queryParams]="{'alarmResponseId': first.content?.secondaryUrl!.split('=')[1]}" -->
              <a class="cursor-pointer font-bold text-daisy-primary"
                [routerLink]="first.content?.secondaryUrl!.split('?')[0] | routerLinkSafeUrl"
                (click)="onHyperLinkClick(first, $event)"
                target="_blank" rel="noopener noreferrer" daisyTooltip="Navigate to Alarm">
                {{ first.content?.secondaryText }}
              </a>
            </div>

            <div class="h-12 shrink-0">
              @if (first.isRead) {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                  aria-label="Mark as unread" daisyTooltip="Mark as unread"
                  (click)="onMarkNotificationsReadStatusesClick(groupedNotifications().notifications, false, $event)">
                  <i class="fa-regular fa-circle"></i>
                </button>
              } @else {
                <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                  aria-label="Mark as read" daisyTooltip="Mark as read"
                  (click)="onMarkNotificationsReadStatusesClick(groupedNotifications().notifications, true, $event)">
                  <i class="fa-solid fa-circle"></i>
                </button>
              }
            </div>
          </div>

          <div class="my-1 flex justify-between">
            <a class="font-bold text-daisy-primary" [routerLink]="first.content?.tertiaryUrl | routerLinkSafeUrl"
              (click)="onHyperLinkClick(first, $event)"
              [daisyTooltip]="entityLinkTooltip(first.content?.tertiaryUrl)"
              target="_blank" rel="noopener noreferrer">
              @if (first.content?.tertiaryText) {
                <i class="fa-solid" [ngClass]="entityLinkIcon(first.content?.tertiaryUrl)"></i>
                {{ first.content?.tertiaryText }}
              }
            </a>
            @if (!first.content?.fourthText) {
              <span class="text-base-content/60">
                {{ first.createdOn | timeAgo }}
              </span>
            }
          </div>
          @if (first.content?.fourthText) {
            <div class="my-1 flex justify-between">
              <a class="font-bold text-daisy-primary" [routerLink]="first.content?.fourthUrl | routerLinkSafeUrl"
                (click)="onHyperLinkClick(first, $event)" daisyTooltip="Navigate to Incident"
                target="_blank" rel="noopener noreferrer">
                <i class="fa-solid fa-file-lines"></i>
                {{ first.content?.fourthText }}
              </a>
              <span class="text-base-content/60">
                {{ first.createdOn | timeAgo }}
              </span>
            </div>
          }
        </div>
      </span>

      <!-- The same "similar notifications" expander the review and assignment rows use; this one was a
           single-panel PrimeNG accordion doing the same job. -->
      @if (groupedNotifications().count > 1) {
        <div class="mb-2 w-full">
          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-sm h-auto w-full justify-start gap-4 p-3 font-normal"
            [attr.aria-expanded]="isExpanded()" (click)="isExpanded.set(!isExpanded())">
            <i class="fa-solid fa-chevron-right text-base-content/60 transition-transform duration-200" [class.rotate-90]="isExpanded()"></i>
            <daisy-avatar [initials]="'+' + (groupedNotifications().count - 1)" size="2rem" shape="rounded" color="neutral" />
            <span class="text-sm">similar notifications</span>
          </button>

          @if (isExpanded()) {
            <div class="mt-2">
              @for (notification of groupedNotifications().notifications.slice(1); track notification) {
                <span class="notification mb-2 flex w-full items-center rounded-box px-4"
                  [ngClass]="notification.isRead ? 'read' : 'unread'">
                  <daisy-avatar class="shrink-0" fallbackIcon="fa-solid fa-siren-on" size="2.25rem" shape="rounded" />
                  <div class="ml-3 flex w-full flex-col">
                    <div class="flex items-center justify-between">
                      <div>
                        <span class="items-center">
                          {{ notification.content?.primaryText }}
                        </span>

                        <!-- [queryParams]="{'alarmResponseId': notification.content?.secondaryUrl!.split('=')[1]}" -->
                        <a class="cursor-pointer font-bold text-daisy-primary"
                          (click)="onHyperLinkClick(notification, $event)"
                          [routerLink]="notification.content?.secondaryUrl!.split('?')[0] | routerLinkSafeUrl"
                          target="_blank" rel="noopener noreferrer" daisyTooltip="Navigate to Alarm">
                          {{ notification.content?.secondaryText }}
                        </a>
                      </div>
                      <div class="h-12 shrink-0">
                        @if (notification.isRead) {
                          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-base-content/60"
                            aria-label="Mark as unread" daisyTooltip="Mark as unread"
                            (click)="onMarkNotificationsReadStatusesClick(notification, false, $event)">
                            <i class="fa-regular fa-circle"></i>
                          </button>
                        } @else {
                          <button type="button" class="daisy-btn daisy-btn-ghost daisy-btn-circle daisy-btn-sm text-daisy-primary"
                            aria-label="Mark as read" daisyTooltip="Mark as read"
                            (click)="onMarkNotificationsReadStatusesClick(notification, true, $event)">
                            <i class="fa-solid fa-circle"></i>
                          </button>
                        }
                      </div>
                    </div>
                    <div class="my-1 flex justify-between">
                      @if (notification?.content?.tertiaryText) {
                        <a class="font-bold text-daisy-primary" [routerLink]="notification.content?.tertiaryUrl | routerLinkSafeUrl"
                          (click)="onHyperLinkClick(notification, $event)"
                          [daisyTooltip]="entityLinkTooltip(notification.content?.tertiaryUrl)"
                          target="_blank" rel="noopener noreferrer">
                          <i class="fa-solid" [ngClass]="entityLinkIcon(notification.content?.tertiaryUrl)"></i>
                          {{ notification.content?.tertiaryText }}
                        </a>
                      }
                      @if (!notification.content?.fourthText) {
                        <span class="text-base-content/60">
                          {{ notification.createdOn | timeAgo }}
                        </span>
                      }
                    </div>
                    @if (notification?.content?.fourthText) {
                      <div class="my-1 flex justify-between">
                        <a class="font-bold text-daisy-primary" [routerLink]="notification.content?.fourthUrl | routerLinkSafeUrl"
                          (click)="onHyperLinkClick(notification, $event)" daisyTooltip="Navigate to Incident"
                          target="_blank" rel="noopener noreferrer">
                          <i class="fa-solid fa-file-lines"></i>
                          {{ notification.content?.fourthText }}
                        </a>
                        <span class="text-base-content/60">
                          {{ notification.createdOn | timeAgo }}
                        </span>
                      </div>
                    }
                  </div>
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
